import { SideModal } from '@wk/components-v3-react16';
import React from 'react';
import { useAtomValue } from 'jotai';
import { selectedStepAtom } from '../../../../atoms';
import StepPropertiesForm from './StepPropertiesForm';
import styles from './SidePanelForStep.module.scss';
import { useSidePanelStep } from './useSidePanelStep';

/**
 * Side panel for editing step properties
 * Uses the selectedStepAtom to display and edit the currently selected step
 */
const SidePanelForStep: React.FC = () => {
  const { isSidePanelStepOpen, toggleSidePanelStep } = useSidePanelStep();
  const selectedStep = useAtomValue(selectedStepAtom);

  return (
    <SideModal
      isOpen={isSidePanelStepOpen && selectedStep !== null}
      onUserRequest={toggleSidePanelStep}
      flowClass={styles.sidePanel}
    >
      {selectedStep ? (
        <StepPropertiesForm step={selectedStep} />
      ) : (
        <div className={styles.noStepSelected}>
          No step selected. Please select a step to edit its properties.
        </div>
      )}
    </SideModal>
  );
};

export default SidePanelForStep;
